<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M8,0C3.58,0,0,3.58,0,8C0,12.42,3.58,16,8,16C12.42,16,16,12.42,16,8C16,3.58,12.42,0,8,0C8,0,8,0,8,0ZM8,14C4.69,14,2,11.31,2,8C2,4.69,4.69,2,8,2C11.31,2,14,4.69,14,8C14,11.31,11.31,14,8,14C8,14,8,14,8,14ZM9,7.59C9,7.59,9,4,9,4C9,3.45,8.55,3,8,3C7.45,3,7,3.45,7,4C7,4,7,8,7,8C7,8.28,7.11,8.53,7.29,8.71C7.29,8.71,9.29,10.71,9.29,10.71C9.47,10.89,9.72,11,10,11C10.55,11,11,10.55,11,10C11,9.72,10.89,9.47,10.71,9.29C10.71,9.29,9,7.59,9,7.59C9,7.59,9,7.59,9,7.59Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Time',
} as DefineComponent
</script>
